module.exports = __webpack_public_path__ + "img/baogao.2cdc1bc9.svg";